var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createReducer } from 'typesafe-actions';
import actions from './actions';
export var initState = {};
var reducer = createReducer(initState)
    .handleAction(actions.fetch.request, function (state) { return (__assign(__assign({}, state), { isFetching: true })); })
    .handleAction(actions.fetch.failure, function (state, _a) {
    var payload = _a.payload;
    return (__assign(__assign({}, state), { isFetching: false, fetchError: payload }));
})
    .handleAction(actions.fetch.success, function (state, _a) {
    var payload = _a.payload;
    return (__assign(__assign({}, state), { isFetching: false, hasFetched: true, clients: payload }));
})
    .handleAction(actions.save.request, function (state) { return (__assign(__assign({}, state), { isSaving: true })); })
    .handleAction(actions.save.failure, function (state, _a) {
    var payload = _a.payload;
    return (__assign(__assign({}, state), { isSaving: false, saveError: payload }));
})
    .handleAction(actions.save.success, function (state) { return (__assign(__assign({}, state), { isSaving: false })); });
export default reducer;
//# sourceMappingURL=reducers.js.map